import { render, staticRenderFns } from "./EditPost.vue?vue&type=template&id=036b310c"
import script from "./EditPost.vue?vue&type=script&lang=ts"
export * from "./EditPost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports